import { render, staticRenderFns } from "./NavigationMenuAdminInfo.vue?vue&type=template&id=a452992e"
import script from "./NavigationMenuAdminInfo.vue?vue&type=script&lang=js"
export * from "./NavigationMenuAdminInfo.vue?vue&type=script&lang=js"
import style0 from "./NavigationMenuAdminInfo.vue?vue&type=style&index=0&id=a452992e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports